import { render, staticRenderFns } from "./OfficeSeal.vue?vue&type=template&id=170746f0&scoped=true&"
import script from "./OfficeSeal.vue?vue&type=script&lang=js&"
export * from "./OfficeSeal.vue?vue&type=script&lang=js&"
import style0 from "./OfficeSeal.vue?vue&type=style&index=0&id=170746f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170746f0",
  null
  
)

export default component.exports